import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
  Link
} from "@material-ui/core";
import React from "react";
import { KeyboardArrowRight } from "@material-ui/icons";

export function Admission(props) {
  const { data } = props;
  const preventDefault = (event) => event.preventDefault();
  const admissionData = {
    acceptanceRate: {
      title: "Acceptance Rate",
      value:
        data.acceptanceRate && typeof data.acceptanceRate == "number"
          ? (data.acceptanceRate * 100).toFixed(2) + "%"
          : null,
    },
    secondarySchoolRecordRequirement: {
      title: "Secondary School Record Requirement",
      value: data.secondarySchoolRecordRequirement,
    },
    totalApplicants: {
      title: "Total Applicants",
      value: data.totalApplicants,
    },
    totalEnrolled: {
      title: "Total Enrolled",
      value: data.totalEnrolled,
    },
    hsRankRequirement: {
      title: "HS Rank Requirement",
      value: data.hsRankRequirement,
    },
    admissionsWebsite: {
      title: "Admissions Website",
      value: data.admissionsWebsite,
    },
    // applicationWebsite: {
    //   title: "Application Website",
    //   value: data.applicationWebsite,
    // },
  };

  return (
    <Card className="pt-5 px-5">
      <CardHeader title="Admission"></CardHeader>
      <CardContent>
        <Grid container spacing={5}>
          <Grid item xs>
            <Box>
              <Typography variant="h6">
                {admissionData.acceptanceRate.title}
              </Typography>
              <Typography variant="h4" color="secondary">
                {admissionData.acceptanceRate.value}
              </Typography>
            </Box>
            <Box>
              <List>
                {[
                  "secondarySchoolRecordRequirement",
                  "totalApplicants",
                  "totalEnrolled",
                  "hsRankRequirement",
                ].map((keyName, index) => (
                  <>
                    <ListItem key={index}>
                      <ListItemText>
                        <Typography>{admissionData[keyName].title}</Typography>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <Typography>
                          {admissionData[keyName].value
                            ? admissionData[keyName].value
                            : "--"}
                        </Typography>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                  </>
                ))}
                {["admissionsWebsite"].map((keyName, index) => (
                  <Box key={index}>
                    <ListItem>
                      <ListItemText>
                        <Typography>{admissionData[keyName].title}</Typography>
                      </ListItemText>
                      <ListItemSecondaryAction>
                        <Typography>
                          <a
                            href={
                              admissionData[keyName].value
                                ? "https://" + admissionData[keyName].value
                                : "#"
                            }
                          >
                            {admissionData[keyName].value ? "Click Here" : "--"}
                          </a>
                        </Typography>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                  </Box>
                ))}
              </List>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
      <hr className="mb-0" />
      <CardActions>
        <Typography variant="body1" color="primary" className="ml-auto mr-2">
          <Link href={window.location.href+"/admission"} onLClick={preventDefault}>
            Read More about Admissions <KeyboardArrowRight />
          </Link>
        </Typography>
      </CardActions>
    </Card>
  );
}
